import Actions from '../../odata/actions';

const actions = new Actions('drainedWeight', 'drainedWeights');

export default actions;
